// import React, { useEffect, useState } from "react";
// import Layout, { Container } from "../components/layout";
// import { Link } from "react-router-dom";
// import { apiurl } from "../config/config";
// import axios from "axios";
// import { SuwasthiLoader } from "../components/loader";
// import { FaPlus } from "react-icons/fa";
// import Pagination from "../components/pagination";
// import { getCookie } from "../config/webStorage";
// import { useUser } from "../config/userProvider";

// const PurchaseOrders = () => {
//   const [purchaseOrders, setPurchaseOrders] = useState([]);
//   const [search, setSearch] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [paginationData, setPaginationData] = useState("");
//   const [currentPage, setCurrentPage] = useState(1);
//   const [itemsPerPage, setItemsPerPage] = useState(100);
//   const [totalItems, setTotalItems] = useState(0);
//   const [totalPages, setTotalPages] = useState(1);
//   const [page, setPage] = useState(1);
//     let token = getCookie("scspt");
//     const { userData } = useUser();
//     console.log("User Data:", userData);

// const fetchMaterials = async () => {
//   try {
//     setLoading(true);
//     const response = await axios.get(`${apiurl}/api/purchase-order/get`, {
//       params: {
//         page,
//         limit: itemsPerPage,
//         search,
//       },
//       headers: {
//         Authorization: `${token}`,
//       },
//     });

//     const { data, pagination } = response.data;
//     setPurchaseOrders(data || []);
//     setPaginationData(pagination);
//     setTotalItems(pagination.totalItems || 0);
//     setCurrentPage(pagination.currentPage || 1);
//     setTotalPages(pagination.totalPages || 1);
//   } catch (error) {
//     console.error("Failed to fetch materials", error);
//   } finally {
//     setLoading(false);
//   }
// };


//   useEffect(() => {
//     fetchMaterials();
//   }, [page, itemsPerPage]);

//   const handleSearch = () => {
//     setPage(1);
//     fetchMaterials();
//   };

//   const handleLimitChange = (e) => {
//     setItemsPerPage(parseInt(e.target.value, 10));
//     setPage(1);
//   };


//   const statusBadge = (status) => {
//   const map = {
//     Draft: "bg-gray-200 text-gray-700",
//     Approved: "bg-blue-100 text-blue-700",
//     Closed: "bg-green-100 text-green-700",
//     Rejected: "bg-red-100 text-red-700",
//   };
//   return map[status] || "bg-gray-100";
// };

// const paymentBadge = (status) => {
//   const map = {
//     Unpaid: "bg-red-100 text-red-700",
//     Partial: "bg-yellow-100 text-yellow-700",
//     Paid: "bg-green-100 text-green-700",
//   };
//   return map[status] || "bg-gray-100";
// };


//   return (
//     <Layout>
//       <Container overflow="overflow-scroll">
//         <div className="p-2 bg-gray-100 min-h-screen">
//           {/* Top Bar */}
//           <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-6 gap-3">
//             {/* Search */}
//             <div className="flex items-center gap-2 w-full md:w-1/2">
//               <input
//                 type="text"
//                 placeholder="Search by name, category, etc."
//                 className="p-2 border w-full focus:outline-none focus:ring-2 focus:ring-[#4B49AC]"
//                 value={search}
//                 onChange={(e) => setSearch(e.target.value)}
//               />
//               <button
//                 onClick={handleSearch}
//                 className="flex items-center gap-2 px-4 py-2 bg-[#4B49AC] text-white rounded"
//               >
//                 Search
//               </button>
//             </div>

//             {/* Controls */}
//             <div className="flex flex-wrap gap-2 justify-start md:justify-end items-center w-full md:w-auto">
//               <select
//                 className="p-2 border focus:outline-none focus:ring-2 focus:ring-[#4B49AC]"
//                 value={itemsPerPage}
//                 onChange={handleLimitChange}
//               >
//                 {[100, 200, 500, 1000].map((n) => (
//                   <option key={n} value={n}>
//                     {n}
//                   </option>
//                 ))}
//               </select>

//        <Link to="/purchase-orders/create"
//                 className="flex items-center gap-2 px-4 py-2 bg-[#4B49AC] text-white rounded"
//               >
//                 <FaPlus /> New PO
//               </Link>
//             </div>
//           </div>

//           {/* Table */}
//           {loading ? (
//             <SuwasthiLoader />
//           ) : (
//             <div className="mt-6 mx-4">
//               {purchaseOrders.length === 0 ? (
//                 <p className="text-red-600">No raw material found.</p>
//               ) : (
//                 <>
//                   <p className="text-lg mb-3 text-gray-700 font-medium">
//                     Total Items: {purchaseOrders.length}
//                   </p>
//                   <div className="overflow-x-auto">
//                     <table className="w-full border border-gray-300">
// <thead>
//   <tr className="bg-[#4B49AC] text-white">
//     <th className="px-3 py-2 border">S.No</th>
//     <th className="px-3 py-2 border">PO No</th>
//     <th className="px-3 py-2 border">Supplier</th>
//     <th className="px-3 py-2 border">PO Status</th>
//     <th className="px-3 py-2 border">PO Amount</th>
//     <th className="px-3 py-2 border">Paid</th>
//     <th className="px-3 py-2 border">Balance</th>
//     <th className="px-3 py-2 border">Payment Status</th>
//     <th className="px-3 py-2 border">PO Date</th>
//     <th className="px-3 py-2 border">Action</th>
//   </tr>
// </thead>
//              <tbody>
//   {purchaseOrders.map((item, idx) => (
//     <tr key={item._id} className="border-b hover:bg-gray-50">
//       <td className="px-3 py-2 border">
//         {(page - 1) * itemsPerPage + idx + 1}
//       </td>

//       <td className="px-3 py-2 border font-medium">
//         {item.poNumber}
//       </td>

//       <td className="px-3 py-2 border capitalize">
//         {item?.supplier?.name || "-"}
//       </td>

//       {/* PO Status */}
//       <td className="px-3 py-2 border">
//         <span
//           className={`px-2 py-1 rounded text-xs font-semibold ${statusBadge(
//             item.status
//           )}`}
//         >
//           {item.status}
//         </span>
//       </td>

//       {/* PO Amount */}
//       <td className="px-3 py-2 border text-right font-semibold">
//         ₹ {item.totalAmount?.toLocaleString() || 0}
//       </td>

//       {/* Paid */}
//       <td className="px-3 py-2 border text-right text-green-700">
//         ₹ {item.paidAmount?.toLocaleString() || 0}
//       </td>

//       {/* Balance */}
//       <td className="px-3 py-2 border text-right text-red-600">
//         ₹ {item.balanceAmount?.toLocaleString() || item.totalAmount || 0}
//       </td>

//       {/* Payment Status */}
//       <td className="px-3 py-2 border">
//         <span
//           className={`px-2 py-1 rounded text-xs font-semibold ${paymentBadge(
//             item.paymentStatus || "Unpaid"
//           )}`}
//         >
//           {item.paymentStatus || "Unpaid"}
//         </span>
//       </td>

//       {/* Date */}
//       <td className="px-3 py-2 border">
//         {new Date(item.poDate || item.createdAt).toLocaleDateString()}
//       </td>

//       {/* Action */}
//       <td className="px-3 py-2 border">
//         <Link
//           to={`/purchase-orders/${item._id}`}
//           className="px-3 py-1 text-sm bg-[#4B49AC] text-white rounded hover:bg-[#3e3c94]"
//         >
//           View
//         </Link>
//       </td>
//     </tr>
//   ))}
// </tbody>

//                     </table>
//                   </div>

//                   <Pagination
//                     currentPage={currentPage}
//                     totalItems={totalItems}
//                     itemsPerPage={itemsPerPage}
//                     onPageChange={(newPage) => setPage(newPage)} // ✅ Use `page` state
//                   />
//                 </>
//               )}
//             </div>
//           )}
//         </div>
//       </Container>
//     </Layout>
//   );
// };

// export default PurchaseOrders;
import React, { useEffect, useState, useCallback } from "react";
import Layout, { Container } from "../components/layout";
import { Link } from "react-router-dom";
import { apiurl } from "../config/config";
import axios from "axios";
import { SuwasthiLoader } from "../components/loader";
import { FaPlus } from "react-icons/fa";
import Pagination from "../components/pagination";
import { getCookie } from "../config/webStorage";
import { useUser } from "../config/userProvider";

const PurchaseOrders = () => {
  const [purchaseOrders, setPurchaseOrders] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(100);
  const [totalItems, setTotalItems] = useState(0);

  const token = getCookie("scspt");
  const { userData } = useUser();

  console.log("User Data:", userData);

  // Fetch purchase orders
  const fetchPurchaseOrders = useCallback(async () => {
    try {
      setLoading(true);

      const response = await axios.get(`${apiurl}/api/purchase-order/get`, {
        params: {
          page,
          limit: itemsPerPage,
          search: search.trim() || undefined,
        },
        headers: {
          Authorization: `${token}`,
        },
      });

      const { data, pagination } = response.data;
      setPurchaseOrders(data || []);
      setTotalItems(pagination?.totalItems || 0);
    } catch (error) {
      console.error("Failed to fetch purchase orders", error);
    } finally {
      setLoading(false);
    }
  }, [page, itemsPerPage, search, token]);

  // Fetch on mount & when dependencies change
  useEffect(() => {
    fetchPurchaseOrders();
  }, [fetchPurchaseOrders]);

  const handleSearch = () => {
    setPage(1); // reset page on new search
    fetchPurchaseOrders();
  };

  const handleLimitChange = (e) => {
    setItemsPerPage(parseInt(e.target.value, 10));
    setPage(1); // reset page
  };

  const statusBadge = (status) => {
    const map = {
      Draft: "bg-gray-200 text-gray-700",
      Approved: "bg-blue-100 text-blue-700",
      Closed: "bg-green-100 text-green-700",
      Rejected: "bg-red-100 text-red-700",
    };
    return map[status] || "bg-gray-100";
  };

  const paymentBadge = (status) => {
    const map = {
      Unpaid: "bg-red-100 text-red-700",
      Partial: "bg-yellow-100 text-yellow-700",
      Paid: "bg-green-100 text-green-700",
    };
    return map[status] || "bg-gray-100";
  };

  return (
    <Layout>
      <Container overflow="overflow-scroll">
        <div className="p-2 bg-gray-100 min-h-screen">
          {/* Top Bar */}
          <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-6 gap-3">
            {/* Search */}
            <div className="flex items-center gap-2 w-full md:w-1/2">
              <input
                type="text"
                placeholder="Search by PO No, Supplier, etc."
                className="p-2 border w-full focus:outline-none focus:ring-2 focus:ring-[#4B49AC]"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
              <button
                onClick={handleSearch}
                className="flex items-center gap-2 px-4 py-2 bg-[#4B49AC] text-white rounded"
              >
                Search
              </button>
            </div>

            {/* Controls */}
            <div className="flex flex-wrap gap-2 justify-start md:justify-end items-center w-full md:w-auto">
              <select
                className="p-2 border focus:outline-none focus:ring-2 focus:ring-[#4B49AC]"
                value={itemsPerPage}
                onChange={handleLimitChange}
              >
                {[100, 200, 500, 1000].map((n) => (
                  <option key={n} value={n}>
                    {n}
                  </option>
                ))}
              </select>

              <Link
                to="/purchase-orders/create"
                className="flex items-center gap-2 px-4 py-2 bg-[#4B49AC] text-white rounded"
              >
                <FaPlus /> New PO
              </Link>
            </div>
          </div>

          {/* Table */}
          {loading ? (
            <SuwasthiLoader />
          ) : purchaseOrders.length === 0 ? (
            <p className="text-red-600">No purchase orders found.</p>
          ) : (
            <>
              <p className="text-lg mb-3 text-gray-700 font-medium">
                Total Items: {totalItems}
              </p>

              <div className="overflow-x-auto">
                <table className="w-full border border-gray-300">
                  <thead>
                    <tr className="bg-[#4B49AC] text-white">
                      <th className="px-3 py-2 border">S.No</th>
                      <th className="px-3 py-2 border">PO No</th>
                      <th className="px-3 py-2 border">Supplier</th>
                      <th className="px-3 py-2 border">PO Status</th>
                      <th className="px-3 py-2 border">PO Amount</th>
                      <th className="px-3 py-2 border">Paid</th>
                      <th className="px-3 py-2 border">Balance</th>
                      <th className="px-3 py-2 border">Payment Status</th>
                      <th className="px-3 py-2 border">PO Date</th>
                      <th className="px-3 py-2 border">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {purchaseOrders.map((item, idx) => (
                      <tr key={item._id} className="border-b hover:bg-gray-50">
                        <td className="px-3 py-2 border">
                          {(page - 1) * itemsPerPage + idx + 1}
                        </td>
                        <td className="px-3 py-2 border font-medium">{item.poNumber}</td>
                        <td className="px-3 py-2 border capitalize">{item?.supplier?.name || "-"}</td>
                        <td className="px-3 py-2 border">
                          <span
                            className={`px-2 py-1 rounded text-xs font-semibold ${statusBadge(item.status)}`}
                          >
                            {item.status}
                          </span>
                        </td>
                        <td className="px-3 py-2 border text-right font-semibold">
                          ₹ {item.totalAmount?.toLocaleString() || 0}
                        </td>
                        <td className="px-3 py-2 border text-right text-green-700">
                          ₹ {item.paidAmount?.toLocaleString() || 0}
                        </td>
                        <td className="px-3 py-2 border text-right text-red-600">
                          ₹ {item.balanceAmount?.toLocaleString() || item.totalAmount || 0}
                        </td>
                        <td className="px-3 py-2 border">
                          <span
                            className={`px-2 py-1 rounded text-xs font-semibold ${paymentBadge(item.paymentStatus || "Unpaid")}`}
                          >
                            {item.paymentStatus || "Unpaid"}
                          </span>
                        </td>
                        <td className="px-3 py-2 border">
                          {new Date(item.poDate || item.createdAt).toLocaleDateString()}
                        </td>
                        <td className="px-3 py-2 border">
                          <Link
                            to={`/purchase-orders/${item._id}`}
                            className="px-3 py-1 text-sm bg-[#4B49AC] text-white rounded hover:bg-[#3e3c94]"
                          >
                            View
                          </Link>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* Pagination */}
              <Pagination
                currentPage={page}
                totalItems={totalItems}
                itemsPerPage={itemsPerPage}
                onPageChange={(newPage) => setPage(newPage)}
              />
            </>
          )}
        </div>
      </Container>
    </Layout>
  );
};

export default PurchaseOrders;